import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAmazonaws,
  SiAstro,
  SiFirebase,
  SiJest,
  SiMongodb,
  SiNextdotjs,
  SiReact,
  SiReactquery,
  SiSentry,
  SiSvelte,
  SiTypescript,
  SiVite,
} from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";

const tech = [
  { label: "React", icon: <SiReact /> },
  { label: "React Native", icon: <TbBrandReactNative /> },
  { label: "Next.js", icon: <SiNextdotjs /> },
  { label: "SvelteKit", icon: <SiSvelte /> },
  { label: "Astro.js", icon: <SiAstro /> },
  { label: "TypeScript", icon: <SiTypescript /> },
  { label: "TanStack Query", icon: <SiReactquery /> },
  { label: "Vite", icon: <SiVite /> },
  { label: "Firebase", icon: <SiFirebase /> },
  { label: "MongoDB", icon: <SiMongodb /> },
  { label: "AWS", icon: <SiAmazonaws /> },
  { label: "Jest", icon: <SiJest /> },
  { label: "Sentry", icon: <SiSentry /> },
];

const TechTools = () => {
  return (
    <Row className="skill-grid">
      {tech.map((item) => (
        <Col xs={6} md={4} lg={3} key={item.label}>
          <div className="tech-icons scroll-reveal">
            {item.icon}
            <span>{item.label}</span>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default TechTools;
